import { AnchorContext, AnchorContextModel } from "@toolkit/Framework/Components/AnchorContext/AnchorContext";
import React, { FC, useMemo, useState } from "react";

export const AnchorContextProvider: FC = ({ children }) => {
    const [links, setLinks] = useState<AnchorContextModel["links"]>([]);

    return (
        <AnchorContext.Provider
            value={{
                links,
                setLinks,
            }}
        >
            {children}
        </AnchorContext.Provider>
    );
};
